// analytics
import NFA from 'shared/helpers/analytics/NFAnalytics';

const SHARE_ICON_CLICK = 'share_btn_click';
const TRACK_TYPE = 'event';

export const onShareClick = () => {
  NFA.track({
    event: SHARE_ICON_CLICK,
    type: TRACK_TYPE,
  });
};
